package com.xtream.ui.ui.widget

import androidx.compose.runtime.Composable
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import coil3.compose.AsyncImagePainter
import coil3.compose.ConstraintsSizeResolver
import coil3.compose.LocalPlatformContext
import coil3.compose.rememberAsyncImagePainter
import coil3.request.ImageRequest
import coil3.request.crossfade

@Composable
actual fun rememberPlatformImagePainter(
    src: String?,
    sizeResolver: ConstraintsSizeResolver
): AsyncImagePainter {

    // On JS, we use LocalPlatformContext to ensure the
    // browser environment is correctly captured.
    val context = LocalPlatformContext.current

    val painter = rememberAsyncImagePainter(
        model = ImageRequest.Builder(context)
            .data(src)
            .crossfade(true)
            .build()
    )

    return painter
}

actual val DefaultCardWidth: Dp
    get() = 148.dp
